module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue3.f6616dd6.jpg";